/**
 * HeaderBackButton Component
 * Reusable back button with arrow-back icon (used in ScreenLayout, create flow, etc.)
 */

import React from 'react';
import { Pressable, Platform } from 'react-native';
import { ArrowLeft } from 'lucide-react-native';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations';
import { useTheme } from '../../../src/theme/useTheme';
import { useThemeContext } from '../../../src/theme/ThemeContext';
import { headerBackButtonStyles } from './HeaderBackButton.styles';

interface HeaderBackButtonProps {
  onPress: () => void;
  testID?: string;
}

export const HeaderBackButton: React.FC<HeaderBackButtonProps> = ({ onPress, testID }) => {
  const theme = useTheme();
  const { isDark } = useThemeContext();
  const styles = headerBackButtonStyles;
  const iconColor = isDark ? theme.white : theme.gray[800];

  return (
    <Pressable
      onPress={onPress}
      style={({ pressed, hovered }) => [
        styles.button,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        pressed && styles.buttonPressed,
        hovered && Platform.OS === 'web' && styles.buttonHover,
      ]}
      accessibilityRole="button"
      accessibilityLabel="Go back"
      testID={testID || 'header-back-button'}
    >
      <ArrowLeft size={24} color={iconColor} />
    </Pressable>
  );
};
